<template>
  <div class="tabs-wrapper">
    <div v-if="!tabs || tabs.length === 0" class="loading-placeholder">
      Loading...
    </div>
    <div v-else class="tabs-list" :class="{ 'is-scrollable': tabs.length > 4 }">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="tab"
        :class="{ 'current-tab': index === activeIndex }"
        @click="handleTab(index)"
      >
        {{ tab.title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    tabs: {
      type: Array,
      required: true,
      validator: (tabs) => tabs.every((tab) => tab && tab.title),
    },
    activeIndex: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  methods: {
    handleTab(index) {
      if (this.activeIndex !== index) {
        this.$emit('update:activeIndex', index);
        this.$emit('tab-click', index); // 可选: 额外事件
      }
    },
  },
};
</script>

<style lang="less" scoped>
.tabs-wrapper {
  width: 100%;
  box-sizing: border-box;
}

.tabs-list {
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  min-height: 48px;
  transition: box-shadow 0.2s;
  max-width: 80%;
  margin: 0 auto;
  justify-content: center;
}

.tabs-list.is-scrollable {
  overflow-x: auto;
  flex-wrap: nowrap;
  -webkit-overflow-scrolling: touch;
}

.tab {
  border-bottom: 1px solid #eee;
  background: #f8f8f8;
  flex: 1 1 0;
  min-width: 100px;
  padding: 0 20px;
  height: 60px;
  font-size: 20px;
  line-height: 60px;
  color: #666;
  text-align: center;
  background: transparent;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  white-space: nowrap;
  &:hover {
    background: #ffe7db;
    color: #ff5715;
  }

  &.current-tab {
    background: #ff5715;
    color: #fff;
    font-weight: 600;
  }
}

.loading-placeholder {
  height: 56px;
  line-height: 56px;
  color: #999;
  text-align: center;
  width: 100%;
  background-color: #f1f1f1;
  border-radius: 8px;
}

@media (max-width: 1280px) {
  .tab {
    font-size: 20px;
    min-width: 80px;
    padding: 0 16px;
    height: 60px;
    line-height: 60px;
  }

  .tabs-list {
    min-height: 60px;
  }
}

@media (max-width: 900px) {
  .tabs-list {
    border-radius: 0;
    min-height: 60px;
    max-width: 100%;
  }

  .tab {
    font-size: 16px;
    min-width: 70px;
    max-width: unset;
    white-space: normal; /* Allow text to wrap */
    height: auto; /* Adjust height to content */
    min-height: 60px; /* Maintain a minimum height */
    line-height: 1.4; /* Suitable for multi-line text */
    padding: 10px 5px; /* Add padding for wrapped text */
    display: flex; /* For centering text */
    align-items: center; /* For centering text */
    justify-content: center; /* For centering text */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Tabs.vue